import type { components } from "@/api/schema";

export type NotificationSettings = components["schemas"]["NotificationSettings"];
export type NotificationRoutingRule = components["schemas"]["NotificationRoutingRule"];
export type ChannelRecipients = components["schemas"]["ChannelRecipients"];
export type MuteWindow = components["schemas"]["MuteWindow"];
export type Channel = keyof ChannelRecipients;
export type ChannelPreviews = components["schemas"]["TestSendResponse"]["previews"];
export type ChannelTestResult = components["schemas"]["TestSendChannelResult"];

export const CHANNELS: readonly Channel[] = ["telegram", "email"] as const;

export function channelLabelKey(c: Channel): string {
  return `channel.${c}`;
}
